import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { LoadingScreen } from '@/components/common';
import { ROUTES } from './routes';

const HomePage = lazy(() => import('@/features/landing/pages/HomePage'));
const ContactPage = lazy(() => import('@/features/contact/pages/ContactPage'));
const ForStudentPage = lazy(() => import('@/features/candidate/pages/ForStudentPage'));
const ForCollegePage = lazy(() => import('@/features/college/pages/ForCollegePage'));
const ForEmployerPage = lazy(() => import('@/features/employer/pages/ForEmployerPage'));
const VirtualJobFairPage = lazy(() => import('@/features/virtualJobFair/pages/VirtualJobFairPage'));
const VJFLoginPage = lazy(() => import('@/features/virtualJobFair/pages/VJFLoginPage'));
const AboutPage = lazy(() => import('@/features/about/pages/AboutPage'));
const EventsBlogPage = lazy(() => import('@/features/eventsBlog/pages/EventsBlogPage'));
const GetStartedPage = lazy(() => import('@/features/getStarted/pages/GetStartedPage'));
const BookDemoPage = lazy(() => import('@/features/bookDemo/pages/BookDemoPage'));
const PrivacyPolicyPage = lazy(() => import('@/features/privacyPolicy/pages/PrivacyPolicyPage'));
const TermsAndConditionsPage = lazy(() => import('@/features/termsAndConditions/pages/TermsAndConditionsPage'));
const NotFoundPage = lazy(() => import('@/components/common/NotFoundPage'));

export const AppRoutes: React.FC = () => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        <Route path={ROUTES.home} element={<HomePage />} />
        <Route path={ROUTES.contact} element={<ContactPage />} />
        <Route path={ROUTES.forCandidate} element={<ForStudentPage />} />
        <Route path={ROUTES.forCollege} element={<ForCollegePage />} />
        <Route path={ROUTES.forEmployer} element={<ForEmployerPage />} />
        <Route path={ROUTES.virtualJobFair} element={<VirtualJobFairPage />} />
        <Route path={ROUTES.virtualJobFairLogin} element={<VJFLoginPage />} />
        <Route path={ROUTES.about} element={<AboutPage />} />
        <Route path={ROUTES.eventsBlog} element={<EventsBlogPage />} />
        <Route path={ROUTES.getStarted} element={<GetStartedPage />} />
        <Route path={ROUTES.bookDemo} element={<BookDemoPage />} />
        <Route path={ROUTES.privacyPolicy} element={<PrivacyPolicyPage />} />
        <Route path={ROUTES.termsAndConditions} element={<TermsAndConditionsPage />} />
        <Route path={ROUTES.notFound} element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
};
